<template>
  <!-- 重置密码 -->
  <div class="forget-password">
    <el-form
      :model="ruleForm"
      :rules="rules"
      ref="ruleForm"
      label-width="auto"
      class="demo-ruleForm"
      label-position="top"
    >
      <div class="title">{{ $t("pages.login.text15") }}</div>
      <el-form-item :label="$t('pages.login.text16')" prop="password">
        <el-input v-model="ruleForm.password" show-password></el-input>
      </el-form-item>
      <el-form-item :label="$t('pages.login.text17')" prop="confirmPassword">
        <el-input v-model="ruleForm.confirmPassword" show-password></el-input>
      </el-form-item>
      <el-form-item>
        <el-button class="btn" type="primary" @click="submit()">{{
          $t("pages.login.text18")
        }}</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import { validatePassword, pwdAgainCheck } from "../../utils/util/test";
import { mapState } from "vuex";
export default {
  data() {
    return {
      ruleForm: {
        mailAddress: null,// 邮箱
        confirmPassword: "", //确认密码
        password: "", // 密码
        trustCode: "", // code
      },
      rules: {
        password: [{ validator: validatePassword, trigger: "blur" }],
        confirmPassword: [{ validator: pwdAgainCheck, trigger: "blur" }],
      },
    };
  },
  mounted() {
    this.ruleForm.mailAddress = this.$route.query.mailAddress;
    this.ruleForm.trustCode = this.$route.query.trustCode;
  },
  computed: {
    ...mapState(["platformData"]),
  },
  methods: {
    //提交
    submit() {
      this.$refs["ruleForm"].validate((valid) => {
        let that = this;
        if (valid) {
          this.ruleForm.platformId = "" + this.platformData.id;
          this.request
            .resetSysUserPasswordByMail(this.ruleForm)
            .then(() => {
              this.$message.success(that.$t("pages.login.text19"));
              setTimeout(() => {
                this.$router.push({ path: "/login" });
              }, 1000);
            })
            .catch((err) => {
              this.$message.error(err.msg);
            });
        }
      });
    },
  },
};
</script>

<style scoped>
.forget-password {
  height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.demo-ruleForm {
  width: 340px;
  margin-top: 200px;
}

.btn {
  width: 100%;
  border-radius: 15px;
}
.title {
  font-size: 20px;
  font-weight: bold;
  margin-bottom: 20px;
}
</style>